export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type FieldWrapper<T> = T;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type IClient = {
  __typename?: 'Client';
  code: FieldWrapper<Scalars['String']['output']>;
  id: FieldWrapper<Scalars['ID']['output']>;
  name: FieldWrapper<Scalars['String']['output']>;
  shortName?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IClientEdge = {
  __typename?: 'ClientEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IClient>;
};

export type IClientsConnection = {
  __typename?: 'ClientsConnection';
  edges: Array<FieldWrapper<IClientEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IConfirmInternalRegulationObligationRuleControlMappingsInput = {
  regulationObligationRuleId: Scalars['ID']['input'];
};

export type IConfirmRegulationObligationInput = {
  obligationId: Scalars['ID']['input'];
};

export type ICreateInternalMappingsJobInput = {
  clientCode: Scalars['String']['input'];
  documentInstanceId?: InputMaybe<Scalars['ID']['input']>;
  regulationId: Scalars['ID']['input'];
};

export type ICreateInternalRegulationObligationProcessInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  obligationId: Scalars['ID']['input'];
};

export type ICreateInternalRegulationObligationRiskInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  obligationId: Scalars['ID']['input'];
};

export type ICreateInternalRegulationObligationRuleControlInput = {
  controlId: Scalars['ID']['input'];
  regulationObligationRuleId: Scalars['ID']['input'];
};

export type ICreateInternalRegulationObligationRuleInput = {
  name: Scalars['String']['input'];
  obligationId: Scalars['ID']['input'];
};

export type ICursorPageInfo = {
  __typename?: 'CursorPageInfo';
  endCursor?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  hasNextPage: FieldWrapper<Scalars['Boolean']['output']>;
};

export type ICursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type IDeleteInternalRegulationObligationProcessInput = {
  id: Scalars['ID']['input'];
};

export type IDeleteInternalRegulationObligationRiskInput = {
  id: Scalars['ID']['input'];
};

export type IDeleteInternalRegulationObligationRuleControlInput = {
  id: Scalars['ID']['input'];
};

export type IDeleteInternalRegulationObligationRuleInput = {
  id: Scalars['ID']['input'];
};

export enum IFilterGroupName {
  DocumentSelectionModal = 'DOCUMENT_SELECTION_MODAL'
}

export type IFilterGroupV2 = {
  __typename?: 'FilterGroupV2';
  availableFilters: Array<FieldWrapper<IFilterPayloadValue>>;
  label?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IFilterInput = {
  groups?: InputMaybe<Array<IFilterInputGroup>>;
};

export type IFilterInputGroup = {
  filterValues: Array<IFilterInputValue>;
  groupKey: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type IFilterInputValue = {
  label?: InputMaybe<Scalars['String']['input']>;
  sublabel?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type IFilterListLevelVariant = {
  __typename?: 'FilterListLevelVariant';
  appliedFilters: Array<FieldWrapper<IFilterPayloadListValue>>;
  appliedFiltersCount: FieldWrapper<Scalars['Int']['output']>;
  searchPlaceholder?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IFilterListVariant = {
  __typename?: 'FilterListVariant';
  appliedFilters: Array<FieldWrapper<IFilterPayloadValue>>;
  appliedFiltersCount: FieldWrapper<Scalars['Int']['output']>;
  filterGroups: Array<FieldWrapper<IFilterGroupV2>>;
  searchPlaceholder?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IFilterPayloadInputGroup = {
  __typename?: 'FilterPayloadInputGroup';
  filterValues: Array<FieldWrapper<IFilterPayloadValue>>;
  groupKey: FieldWrapper<Scalars['String']['output']>;
  label?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IFilterPayloadListValue = {
  __typename?: 'FilterPayloadListValue';
  code: FieldWrapper<Scalars['String']['output']>;
  hasChildren?: Maybe<FieldWrapper<Scalars['Boolean']['output']>>;
  label?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  lastLevelFilterCount?: Maybe<FieldWrapper<Scalars['Int']['output']>>;
  parentIds?: Maybe<Array<FieldWrapper<Scalars['String']['output']>>>;
  siblingCounts?: Maybe<FieldWrapper<Scalars['Int']['output']>>;
  sublabel?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  value: FieldWrapper<Scalars['String']['output']>;
};

export type IFilterPayloadValue = {
  __typename?: 'FilterPayloadValue';
  label?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  sublabel?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  value: FieldWrapper<Scalars['String']['output']>;
};

export type IFilterRange = {
  __typename?: 'FilterRange';
  max: FieldWrapper<Scalars['Int']['output']>;
  min: FieldWrapper<Scalars['Int']['output']>;
};

export type IFilterRangeVariant = {
  __typename?: 'FilterRangeVariant';
  activeRange?: Maybe<FieldWrapper<IFilterRange>>;
  range: FieldWrapper<IFilterRange>;
};

export type IFilterResponse = {
  __typename?: 'FilterResponse';
  allFilters: Array<FieldWrapper<IFilterV2>>;
  exposedFilterIds: Array<FieldWrapper<Scalars['ID']['output']>>;
};

export enum IFilterType {
  GroupList = 'GROUP_LIST',
  List = 'LIST',
  ListLevel = 'LIST_LEVEL',
  RadioList = 'RADIO_LIST',
  Range = 'RANGE'
}

export type IFilterV2 = {
  __typename?: 'FilterV2';
  attributes: FieldWrapper<IFilterVariant>;
  code: FieldWrapper<Scalars['String']['output']>;
  description?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  id: FieldWrapper<Scalars['ID']['output']>;
  info?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  label: FieldWrapper<Scalars['String']['output']>;
  type: FieldWrapper<IFilterType>;
};

export type IFilterVariant = IFilterListLevelVariant | IFilterListVariant | IFilterRangeVariant;

export type IInternalControl = {
  __typename?: 'InternalControl';
  code: FieldWrapper<Scalars['String']['output']>;
  id: FieldWrapper<Scalars['ID']['output']>;
  latestInstance?: Maybe<FieldWrapper<IInternalControlInstance>>;
  latestName?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IInternalControlConnection = {
  __typename?: 'InternalControlConnection';
  edges: Array<FieldWrapper<IInternalControlEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalControlEdge = {
  __typename?: 'InternalControlEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalControl>;
};

export type IInternalControlInstance = {
  __typename?: 'InternalControlInstance';
  automation?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  controlId: FieldWrapper<Scalars['ID']['output']>;
  descriptionAction?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  descriptionIdentify?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  descriptionReview?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  id: FieldWrapper<Scalars['ID']['output']>;
  name: FieldWrapper<Scalars['String']['output']>;
  objective?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  type?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IInternalControlsInput = {
  filters?: InputMaybe<IFilterInput>;
  sort?: InputMaybe<Array<ISortInput>>;
};

export type IInternalDocumentInstancesInput = {
  filters?: InputMaybe<IFilterInput>;
  sort?: InputMaybe<Array<ISortInput>>;
};

export type IInternalFilterOptionsByFilterGroupInput = {
  filterGroupCode: IFilterGroupName;
  filters?: InputMaybe<IFilterInput>;
};

export type IInternalMappingsJob = {
  __typename?: 'InternalMappingsJob';
  clientCode: FieldWrapper<Scalars['String']['output']>;
  createdAt: FieldWrapper<Scalars['String']['output']>;
  documentName?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  id: FieldWrapper<Scalars['ID']['output']>;
  publishedAt?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  regulationId: FieldWrapper<Scalars['ID']['output']>;
  regulationName: FieldWrapper<Scalars['String']['output']>;
  status: FieldWrapper<IInternalMappingsJobStatus>;
};

export type IInternalMappingsJobEdge = {
  __typename?: 'InternalMappingsJobEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalMappingsJob>;
};

export enum IInternalMappingsJobStatus {
  InProgress = 'IN_PROGRESS',
  MappingsCreated = 'MAPPINGS_CREATED',
  Published = 'PUBLISHED'
}

export type IInternalMappingsJobsConnection = {
  __typename?: 'InternalMappingsJobsConnection';
  edges: Array<FieldWrapper<IInternalMappingsJobEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalMappingsJobsInput = {
  filters?: InputMaybe<IFilterInput>;
  sort?: InputMaybe<Array<ISortInput>>;
};

export type IInternalRegulation = {
  __typename?: 'InternalRegulation';
  id?: Maybe<FieldWrapper<Scalars['ID']['output']>>;
  issuanceDate: FieldWrapper<Scalars['String']['output']>;
  status: FieldWrapper<IInternalRegulationReviewStatus>;
  title: FieldWrapper<Scalars['String']['output']>;
};

export type IInternalRegulationDocumentInstance = {
  __typename?: 'InternalRegulationDocumentInstance';
  citation?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  createdTimestamp: FieldWrapper<Scalars['String']['output']>;
  documentCode?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  documentDisplayCode?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  documentUrl?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  documentVersion?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  id: FieldWrapper<Scalars['ID']['output']>;
  level?: Maybe<FieldWrapper<Scalars['Int']['output']>>;
  mappingsReviewStatus: FieldWrapper<IInternalRegulationDocumentReviewStatus>;
  name: FieldWrapper<Scalars['String']['output']>;
  obligationReviewStatus: FieldWrapper<IInternalRegulationDocumentReviewStatus>;
  regulationDocumentId: FieldWrapper<Scalars['ID']['output']>;
};

export type IInternalRegulationDocumentInstanceEdge = {
  __typename?: 'InternalRegulationDocumentInstanceEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalRegulationDocumentInstance>;
};

export type IInternalRegulationDocumentInstancesConnection = {
  __typename?: 'InternalRegulationDocumentInstancesConnection';
  edges: Array<FieldWrapper<IInternalRegulationDocumentInstanceEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export enum IInternalRegulationDocumentReviewStatus {
  InProgress = 'IN_PROGRESS',
  Reviewed = 'REVIEWED',
  ToReview = 'TO_REVIEW'
}

export type IInternalRegulationEdge = {
  __typename?: 'InternalRegulationEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalRegulation>;
};

export type IInternalRegulationFragment = {
  __typename?: 'InternalRegulationFragment';
  body?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  id: FieldWrapper<Scalars['ID']['output']>;
  label?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  level?: Maybe<FieldWrapper<Scalars['Int']['output']>>;
  obligations?: Maybe<FieldWrapper<IInternalRegulationObligationConnection>>;
  reference?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  title?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IInternalRegulationFragmentConnection = {
  __typename?: 'InternalRegulationFragmentConnection';
  edges: Array<FieldWrapper<IInternalRegulationFragmentEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalRegulationFragmentEdge = {
  __typename?: 'InternalRegulationFragmentEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalRegulationFragment>;
};

export type IInternalRegulationFragmentGroup = {
  __typename?: 'InternalRegulationFragmentGroup';
  fragments?: Maybe<Array<FieldWrapper<IInternalRegulationFragment>>>;
  id: FieldWrapper<Scalars['ID']['output']>;
};

export type IInternalRegulationObligation = {
  __typename?: 'InternalRegulationObligation';
  fragment?: Maybe<FieldWrapper<IInternalRegulationFragmentConnection>>;
  id: FieldWrapper<Scalars['ID']['output']>;
  mappingsReviewStatus?: Maybe<FieldWrapper<IInternalRegulationObligationReviewStatus>>;
  reviewStatus?: Maybe<FieldWrapper<IInternalRegulationObligationReviewStatus>>;
  segmentId?: Maybe<FieldWrapper<Scalars['ID']['output']>>;
  title?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export enum IInternalRegulationObligationApprovalStatus {
  Approved = 'APPROVED',
  Disapproved = 'DISAPPROVED',
  PendingApproved = 'PENDING_APPROVED',
  PendingDisapproved = 'PENDING_DISAPPROVED',
  ToReview = 'TO_REVIEW'
}

export type IInternalRegulationObligationConnection = {
  __typename?: 'InternalRegulationObligationConnection';
  edges: Array<FieldWrapper<IInternalRegulationObligationEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalRegulationObligationEdge = {
  __typename?: 'InternalRegulationObligationEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalRegulationObligation>;
};

export type IInternalRegulationObligationProcess = {
  __typename?: 'InternalRegulationObligationProcess';
  id: FieldWrapper<Scalars['ID']['output']>;
  obligationId: FieldWrapper<Scalars['ID']['output']>;
  processCode?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  processDescription?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  processName?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IInternalRegulationObligationProcessConnection = {
  __typename?: 'InternalRegulationObligationProcessConnection';
  edges: Array<FieldWrapper<IInternalRegulationObligationProcessEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalRegulationObligationProcessEdge = {
  __typename?: 'InternalRegulationObligationProcessEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalRegulationObligationProcess>;
};

export type IInternalRegulationObligationProcessesInput = {
  filters?: InputMaybe<IFilterInput>;
  sort?: InputMaybe<Array<ISortInput>>;
};

export enum IInternalRegulationObligationReviewStatus {
  InProgress = 'IN_PROGRESS',
  Reviewed = 'REVIEWED',
  ToReview = 'TO_REVIEW'
}

export type IInternalRegulationObligationReviewSummaryInput = {
  filters?: InputMaybe<IFilterInput>;
};

export type IInternalRegulationObligationRisk = {
  __typename?: 'InternalRegulationObligationRisk';
  approvalStatus?: Maybe<FieldWrapper<IInternalRegulationObligationApprovalStatus>>;
  id: FieldWrapper<Scalars['ID']['output']>;
  isFromObligation: FieldWrapper<Scalars['Boolean']['output']>;
  name?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  obligationId: FieldWrapper<Scalars['ID']['output']>;
};

export type IInternalRegulationObligationRiskConnection = {
  __typename?: 'InternalRegulationObligationRiskConnection';
  edges: Array<FieldWrapper<IInternalRegulationObligationRiskEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalRegulationObligationRiskEdge = {
  __typename?: 'InternalRegulationObligationRiskEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalRegulationObligationRisk>;
};

export type IInternalRegulationObligationRisksInput = {
  filters?: InputMaybe<IFilterInput>;
  sort?: InputMaybe<Array<ISortInput>>;
};

export type IInternalRegulationObligationRule = {
  __typename?: 'InternalRegulationObligationRule';
  approvalStatus?: Maybe<FieldWrapper<IInternalRegulationObligationApprovalStatus>>;
  displayOrder?: Maybe<FieldWrapper<Scalars['Int']['output']>>;
  id: FieldWrapper<Scalars['ID']['output']>;
  isFromObligation?: Maybe<FieldWrapper<Scalars['Boolean']['output']>>;
  name: FieldWrapper<Scalars['String']['output']>;
  obligationId: FieldWrapper<Scalars['ID']['output']>;
  reviewStatus?: Maybe<FieldWrapper<IInternalRegulationObligationRuleReviewStatus>>;
};

export type IInternalRegulationObligationRuleConnection = {
  __typename?: 'InternalRegulationObligationRuleConnection';
  edges: Array<FieldWrapper<IInternalRegulationObligationRuleEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalRegulationObligationRuleControl = {
  __typename?: 'InternalRegulationObligationRuleControl';
  approvalStatus?: Maybe<FieldWrapper<IInternalRegulationObligationApprovalStatus>>;
  comment?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  control?: Maybe<FieldWrapper<IInternalControl>>;
  controlId: FieldWrapper<Scalars['ID']['output']>;
  id: FieldWrapper<Scalars['ID']['output']>;
  isFromModel: FieldWrapper<Scalars['Boolean']['output']>;
  reason?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  regulationObligationRuleId: FieldWrapper<Scalars['ID']['output']>;
};

export type IInternalRegulationObligationRuleControlConnection = {
  __typename?: 'InternalRegulationObligationRuleControlConnection';
  edges: Array<FieldWrapper<IInternalRegulationObligationRuleControlEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalRegulationObligationRuleControlEdge = {
  __typename?: 'InternalRegulationObligationRuleControlEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalRegulationObligationRuleControl>;
};

export type IInternalRegulationObligationRuleControlsInput = {
  filters?: InputMaybe<IFilterInput>;
  sort?: InputMaybe<Array<ISortInput>>;
};

export type IInternalRegulationObligationRuleEdge = {
  __typename?: 'InternalRegulationObligationRuleEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalRegulationObligationRule>;
};

export enum IInternalRegulationObligationRuleReviewStatus {
  Reviewed = 'REVIEWED',
  ToReview = 'TO_REVIEW'
}

export type IInternalRegulationObligationRulesInput = {
  filters?: InputMaybe<IFilterInput>;
  sort?: InputMaybe<Array<ISortInput>>;
};

export type IInternalRegulationObligationsInput = {
  filters?: InputMaybe<IFilterInput>;
};

export type IInternalRegulationObligationsReviewSummary = {
  __typename?: 'InternalRegulationObligationsReviewSummary';
  reviewedObligationsCount: FieldWrapper<Scalars['Int']['output']>;
  totalObligationsCount: FieldWrapper<Scalars['Int']['output']>;
};

export enum IInternalRegulationReviewStatus {
  InProgress = 'IN_PROGRESS',
  Reviewed = 'REVIEWED',
  ToReview = 'TO_REVIEW'
}

export type IInternalRegulationSegment = {
  __typename?: 'InternalRegulationSegment';
  fragmentGroups?: Maybe<Array<FieldWrapper<IInternalRegulationFragmentGroup>>>;
  fragments?: Maybe<Array<FieldWrapper<IInternalRegulationFragment>>>;
  id: FieldWrapper<Scalars['ID']['output']>;
  reference?: Maybe<FieldWrapper<Scalars['String']['output']>>;
  regulationDocumentInstanceId?: Maybe<FieldWrapper<Scalars['ID']['output']>>;
  sectionName?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};

export type IInternalRegulationSegmentConnection = {
  __typename?: 'InternalRegulationSegmentConnection';
  edges: Array<FieldWrapper<IInternalRegulationSegmentEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalRegulationSegmentEdge = {
  __typename?: 'InternalRegulationSegmentEdge';
  cursor: FieldWrapper<Scalars['String']['output']>;
  node: FieldWrapper<IInternalRegulationSegment>;
};

export type IInternalRegulationSegmentsInput = {
  filters?: InputMaybe<IFilterInput>;
  sort?: InputMaybe<Array<ISortInput>>;
};

export type IInternalRegulationsConnection = {
  __typename?: 'InternalRegulationsConnection';
  edges: Array<FieldWrapper<IInternalRegulationEdge>>;
  pageInfo: FieldWrapper<ICursorPageInfo>;
};

export type IInternalRegulationsInput = {
  filters?: InputMaybe<IFilterInput>;
  sort?: InputMaybe<Array<ISortInput>>;
};

export type IMutation = {
  __typename?: 'Mutation';
  confirmInternalRegulationObligationRuleControlMappings: FieldWrapper<Scalars['Boolean']['output']>;
  confirmRegulationObligation: FieldWrapper<IInternalRegulationObligation>;
  createInternalMappingsJob: FieldWrapper<IInternalMappingsJob>;
  createInternalRegulationObligationProcess: FieldWrapper<IInternalRegulationObligationProcess>;
  createInternalRegulationObligationRisk: FieldWrapper<IInternalRegulationObligationRisk>;
  createInternalRegulationObligationRule: FieldWrapper<IInternalRegulationObligationRule>;
  createInternalRegulationObligationRuleControl: FieldWrapper<IInternalRegulationObligationRuleControl>;
  deleteInternalRegulationObligationProcess: FieldWrapper<IInternalRegulationObligationProcess>;
  deleteInternalRegulationObligationRisk: FieldWrapper<IInternalRegulationObligationRisk>;
  deleteInternalRegulationObligationRule: FieldWrapper<IInternalRegulationObligationRule>;
  deleteInternalRegulationObligationRuleControl: FieldWrapper<IInternalRegulationObligationRuleControl>;
  updateInternalRegulationObligationRule: FieldWrapper<IInternalRegulationObligationRule>;
};


export type IMutationConfirmInternalRegulationObligationRuleControlMappingsArgs = {
  input: IConfirmInternalRegulationObligationRuleControlMappingsInput;
};


export type IMutationConfirmRegulationObligationArgs = {
  input: IConfirmRegulationObligationInput;
};


export type IMutationCreateInternalMappingsJobArgs = {
  input: ICreateInternalMappingsJobInput;
};


export type IMutationCreateInternalRegulationObligationProcessArgs = {
  input: ICreateInternalRegulationObligationProcessInput;
};


export type IMutationCreateInternalRegulationObligationRiskArgs = {
  input: ICreateInternalRegulationObligationRiskInput;
};


export type IMutationCreateInternalRegulationObligationRuleArgs = {
  input: ICreateInternalRegulationObligationRuleInput;
};


export type IMutationCreateInternalRegulationObligationRuleControlArgs = {
  input: ICreateInternalRegulationObligationRuleControlInput;
};


export type IMutationDeleteInternalRegulationObligationProcessArgs = {
  input: IDeleteInternalRegulationObligationProcessInput;
};


export type IMutationDeleteInternalRegulationObligationRiskArgs = {
  input: IDeleteInternalRegulationObligationRiskInput;
};


export type IMutationDeleteInternalRegulationObligationRuleArgs = {
  input: IDeleteInternalRegulationObligationRuleInput;
};


export type IMutationDeleteInternalRegulationObligationRuleControlArgs = {
  input: IDeleteInternalRegulationObligationRuleControlInput;
};


export type IMutationUpdateInternalRegulationObligationRuleArgs = {
  input: IUpdateInternalRegulationObligationRuleInput;
};

export type IQuery = {
  __typename?: 'Query';
  clients: FieldWrapper<IClientsConnection>;
  internalControls: FieldWrapper<IInternalControlConnection>;
  internalDocumentInstances: FieldWrapper<IInternalRegulationDocumentInstancesConnection>;
  internalFilterOptionsByFilterGroup: FieldWrapper<IFilterResponse>;
  internalMappingsJobs: FieldWrapper<IInternalMappingsJobsConnection>;
  internalProcessNames: Array<FieldWrapper<Scalars['String']['output']>>;
  internalRegulationObligationProcesses: FieldWrapper<IInternalRegulationObligationProcessConnection>;
  internalRegulationObligationRisks: FieldWrapper<IInternalRegulationObligationRiskConnection>;
  internalRegulationObligationRuleControls: FieldWrapper<IInternalRegulationObligationRuleControlConnection>;
  internalRegulationObligationRules: FieldWrapper<IInternalRegulationObligationRuleConnection>;
  internalRegulationObligationsByDocument: FieldWrapper<IInternalRegulationObligationConnection>;
  internalRegulationObligationsReviewSummary: FieldWrapper<IInternalRegulationObligationsReviewSummary>;
  internalRegulationSegments: FieldWrapper<IInternalRegulationSegmentConnection>;
  internalRegulations: FieldWrapper<IInternalRegulationsConnection>;
  internalRiskNames: Array<FieldWrapper<Scalars['String']['output']>>;
  me: FieldWrapper<IUser>;
};


export type IQueryClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type IQueryInternalControlsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalControlsInput>;
};


export type IQueryInternalDocumentInstancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalDocumentInstancesInput>;
};


export type IQueryInternalFilterOptionsByFilterGroupArgs = {
  input: IInternalFilterOptionsByFilterGroupInput;
};


export type IQueryInternalMappingsJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalMappingsJobsInput>;
};


export type IQueryInternalRegulationObligationProcessesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalRegulationObligationProcessesInput>;
};


export type IQueryInternalRegulationObligationRisksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalRegulationObligationRisksInput>;
};


export type IQueryInternalRegulationObligationRuleControlsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalRegulationObligationRuleControlsInput>;
};


export type IQueryInternalRegulationObligationRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalRegulationObligationRulesInput>;
};


export type IQueryInternalRegulationObligationsByDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalRegulationObligationsInput>;
};


export type IQueryInternalRegulationObligationsReviewSummaryArgs = {
  input?: InputMaybe<IInternalRegulationObligationReviewSummaryInput>;
};


export type IQueryInternalRegulationSegmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalRegulationSegmentsInput>;
};


export type IQueryInternalRegulationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<IInternalRegulationsInput>;
};

export enum ISortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ISortInput = {
  direction: ISortDirection;
  field: Scalars['String']['input'];
};

export enum IUiTheme {
  Dark = 'DARK',
  Default = 'DEFAULT'
}

export type IUpdateInternalRegulationObligationRuleInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type IUser = {
  __typename?: 'User';
  id: FieldWrapper<Scalars['ID']['output']>;
  name?: Maybe<FieldWrapper<Scalars['String']['output']>>;
};
